/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';

const AssetBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useAssetUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Assets" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default AssetBreadcrumbs;
